const config = {
  configEndpoints: {
    baseEndpoint: "https://api.hub.affinity.io/partner",
  },
};
export default config;
